<button mat-icon-button type="button" (click)="leggTil(-1)">
  <mat-icon>remove</mat-icon>
</button>
<input type="text"
       matInput
       [formControl]="kontroll"
       [matAutocomplete]="stoerrelserMeny"
       (blur)="vedFokusMistet()">
<mat-autocomplete #stoerrelserMeny="matAutocomplete" panelWidth="200px" (opened)="vedMenyAapnet()" (closed)="vedMenyLukket()">
  @for (stoerrelse of stoerrelser; track stoerrelse.stoerrelse) {
    <mat-option [value]="stoerrelse.stoerrelse">{{ stoerrelse.navn }}</mat-option>
  }
</mat-autocomplete>
<button mat-icon-button type="button" (click)="leggTil(+1)">
  <mat-icon>add</mat-icon>
</button>
